module.exports = __webpack_public_path__ + "static/Bernard-Lhermine-2d9d468472e26435d27351d90f9314bc.jpg";